import React, { useState } from 'react';
import { AppBar, Box, Button, Container, Drawer, IconButton, Stack, Toolbar, Typography, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { companyProfile, navItems } from '../data/siteContent';

const asset = (p) => `${process.env.PUBLIC_URL || ''}${p}`;

const LayoutShell = ({ children }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { pathname } = useLocation();

  const navButton = (item) => (
    <Button
      key={item.path}
      component={RouterLink}
      to={item.path}
      sx={{
        color: pathname === item.path ? 'primary.main' : 'text.primary',
        fontWeight: pathname === item.path ? 700 : 500,
        '&:hover': { backgroundColor: 'rgba(30, 64, 175, 0.08)' }
      }}
    >
      {item.label}
    </Button>
  );

  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(180deg, #f5f8ff 0%, #eef4ff 52%, #ffffff 100%)' }}>
      <AppBar
        position="sticky"
        sx={{
          background: 'rgba(255,255,255,0.92)',
          color: 'text.primary',
          borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
          boxShadow: 'none',
          backdropFilter: 'blur(8px)'
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ minHeight: 74 }}>
            <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', mr: 3 }}>
              <Box
                component="img"
                src={asset('/company-mark.svg')}
                alt="TGRELEASE 泰杰儒雅科技"
                sx={{ width: { xs: 170, md: 220 }, height: 'auto' }}
              />
            </Box>

            <Stack direction="row" spacing={1} sx={{ ml: 'auto', display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
              <Box sx={{ display: 'flex', gap: 0.5 }}>{navItems.map(navButton)}</Box>
              <Button
                component={RouterLink}
                to="/consultation"
                variant="contained"
                startIcon={<ChatRoundedIcon />}
                sx={{ ml: 1 }}
              >
                立即咨询
              </Button>
            </Stack>

            {mobile && (
              <IconButton sx={{ ml: 'auto' }} onClick={() => setOpen(true)}>
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 260, p: 2.5, display: 'grid', gap: 0.5 }}>
          <Button
            component={RouterLink}
            to="/consultation"
            variant="contained"
            startIcon={<ChatRoundedIcon />}
            onClick={() => setOpen(false)}
            sx={{ mb: 1, justifyContent: 'flex-start' }}
          >
            立即咨询
          </Button>
          {navItems.map((item) => (
            <Button
              key={item.path}
              component={RouterLink}
              to={item.path}
              onClick={() => setOpen(false)}
              sx={{ justifyContent: 'flex-start', color: pathname === item.path ? 'primary.main' : 'text.primary' }}
            >
              {item.label}
            </Button>
          ))}
        </Box>
      </Drawer>

      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
        {children}
      </Container>

      <Box sx={{ borderTop: '1px solid rgba(15, 23, 42, 0.08)', py: 3, background: '#f8fbff' }}>
        <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography
            component="a"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer"
            variant="body2"
            sx={{
              color: '#1d4ed8',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            {companyProfile.icp}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default LayoutShell;
